import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 40895 38310"
    {...props}
  >
    <defs>
      {/* <style>{".fil0{fill:#322d2c}"}</style> */}
    </defs>
    <g id="Layer_x0020_1">
      <g id="_2528504661008">
        <path
          d="M39116 30580H1778V1779h37338v28801zm1779 890V889c0-491-398-889-890-889H889C398 0 0 399 0 889l1 30581c0 491 397 889 888 889h39116c492 0 890-398 890-889z"
          className="fill"
        />
        <path
          d="M6479 5452h27937v18255H6479V5452zm-889 20032h29715c491 0 889-399 889-888V4564c0-491-399-889-889-889H5590c-491 0-890 398-890 889l1 20032c0 489 398 888 889 888zM20447 28937c-465 0-846-379-846-845s381-843 846-843c466 0 844 377 844 843s-378 845-844 845zm0-2756c-1054 0-1911 857-1911 1911s857 1912 1911 1912c1055 0 1912-857 1912-1912 0-1054-857-1911-1912-1911zM11066 35204h18762v1329H11066v-1329zm19651 3106c492 0 889-396 889-888v-3107c0-492-398-890-889-890H10177c-490 0-889 398-889 890l1 3107c0 492 398 888 888 888h20540z"
          className="fill"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
